export default __webpack_public_path__ + "static/media/bunad.6acedbec.jpg";